import angular from 'angular';
import dashboardComponent from './dashboard.component';
import DashboardService from './dashboard.service';

let dashboardModule = angular.module('dashboard', [])
  .component('dashboard', dashboardComponent)
  .service('dashboardService', DashboardService);

export default dashboardModule;



// WEBPACK FOOTER //
// ./app/components/dashboard/dashboard.js